import React, { useState, useEffect } from "react";

const PwaInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  const [installHover, setInstallHover] = useState(false);
  const [dismissHover, setDismissHover] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const choiceResult = await deferredPrompt.userChoice;
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the PWA installation.");
      } else {
        console.log("User dismissed the PWA installation.");
      }
      setDeferredPrompt(null);
      setShowPrompt(false);
    }
  };

  const handleDismiss = () => {
    setShowPrompt(false);
  };

  const styles = {
    popup: {
      position: "fixed",
      bottom: "20px",
      left: "50%",
      transform: "translateX(-50%)",
      padding: "15px 25px",
      backgroundColor: "#f8f9fa",
      boxShadow: "0 8px 15px rgba(0, 0, 0, 0.2)",
      borderRadius: "12px",
      zIndex: 1000,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      fontSize: "14px",
      color: "#212529",
    },
    buttonContainer: {
      marginTop: "10px",
      display: "flex",
      gap: "10px",
    },
    button: {
      padding: "8px 16px",
      fontSize: "14px",
      fontWeight: "bold",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    installButton: {
      backgroundColor: "#007bff",
      color: "#ffffff",
    },
    installButtonHover: {
      backgroundColor: "#0056b3",
    },
    dismissButton: {
      backgroundColor: "#e9ecef",
      color: "#495057",
    },
    dismissButtonHover: {
      backgroundColor: "#ced4da",
    },
  };

  return (
    showPrompt && (
      <div style={styles.popup}>
        <p>Install this app for a better experience!</p>
        <div style={styles.buttonContainer}>
          <button
            onClick={handleInstall}
            onMouseEnter={() => setInstallHover(true)}
            onMouseLeave={() => setInstallHover(false)}
            style={{
              ...styles.button,
              ...styles.installButton,
              ...(installHover && styles.installButtonHover),
            }}
          >
            Install
          </button>
          <button
            onClick={handleDismiss}
            onMouseEnter={() => setDismissHover(true)}
            onMouseLeave={() => setDismissHover(false)}
            style={{
              ...styles.button,
              ...styles.dismissButton,
              ...(dismissHover && styles.dismissButtonHover),
            }}
          >
            Dismiss
          </button>
        </div>
      </div>
    )
  );
};

export default PwaInstallPrompt;
